import { render, staticRenderFns } from "./TrustedBySection.vue?vue&type=template&id=198d9e12&scoped=true"
import script from "./TrustedBySection.vue?vue&type=script&lang=js"
export * from "./TrustedBySection.vue?vue&type=script&lang=js"
import style0 from "./TrustedBySection.vue?vue&type=style&index=0&id=198d9e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d9e12",
  null
  
)

export default component.exports